import Script from "next/script";

// GA nạp lazyOnload (sau khi trang load xong) thay vì afterInteractive
// của @next/third-parties -> không chiếm main thread lúc đầu (TBT).
const GA_ID = "G-L76923R14P";

export default function GoogleAnalytics() {
  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
        strategy="lazyOnload"
      />
      <Script id="ga-init" strategy="lazyOnload">
        {`window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${GA_ID}');`}
      </Script>
    </>
  );
}
